import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Chapter, Course, Lesson } from '../models/course.model';
import { StandardResponse } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  constructor(private httpClient: HttpClient) { }

  getCourses(): Observable<StandardResponse<Course>> {
    return this.httpClient.get<StandardResponse<Course>>(
      environment.baseServerUrl + `courses`
    );
  }

  getCourse(id: string): Observable<StandardResponse<Course>> {
    return this.httpClient.get<StandardResponse<Course>>(
      environment.baseServerUrl + `courses/${id}`
    )
  }

  createChapter(courseId: String, chapter: Chapter): Observable<Chapter> {
    return this.httpClient.post<Chapter>(
      environment.baseServerUrl + `courses/${courseId}/chapter`, chapter
    )
  }

  createLesson(course: Course, chapter: Chapter, lesson:Lesson): Observable<Lesson> {
    return this.httpClient.post<Lesson>(
      environment.baseServerUrl + `courses/${course.id}/chapter/edit/${chapter.id}`, lesson
    )
  }
}
